interface LogoMarkProps {
  size?: number;
  title?: string;
}

/**
 * The CatalyxLabs mark: an open rounded triangle with a four-point sparkle.
 * Drawn as a single stroked path with a deliberate gap along the base.
 */
export const LogoMark = ({ size = 34, title }: LogoMarkProps) => (
  <svg
    className="logo__mark"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    role={title ? "img" : "presentation"}
    aria-hidden={title ? undefined : true}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M33 49 L20 49 Q11 49 15.35 41.12 L27.65 18.88 Q32 11 36.35 18.88 L48.65 41.12 Q53 49 44 49"
      stroke="currentColor"
      strokeWidth={4.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="logo__sparkle"
      d="M32 24 C32.8 30.5 35.5 33.2 42 34 C35.5 34.8 32.8 37.5 32 44 C31.2 37.5 28.5 34.8 22 34 C28.5 33.2 31.2 30.5 32 24 Z"
      fill="currentColor"
    />
  </svg>
);

export const Wordmark = () => (
  <span className="logo__wordmark">
    Catalyx<span className="logo__wordmark-accent">Labs</span>
  </span>
);
